import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../RoutingAuth/auth.service';
import { BaseBusyableComponent } from '../../../Services/BaseBusyableComponent';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'email-confirm',
     templateUrl: './emailConfirm.html',
     styleUrls: [],
     
})
export class emailConfirmComponent extends BaseBusyableComponent implements OnInit { 


     constructor(
          private authService: AuthService,
          private route: ActivatedRoute, 
     ) {
          super();
     }    
  
     title = "Login";
     disapproved: boolean = false;
     approved: boolean = false;
    
    login() {     
      
      this.authService.login();
    }   

     ngOnInit() {
          
		this.route.params
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(params => {
               var id = params['id'];
               if (id) {
                    this.isSaving = true;
                    //this.personService.getEmailCode(id)
                    //     .pipe(finalize(() => { this.isSaving = false }))
                    //     .subscribe(obj => {
                    //          if (obj) {
                    //               this.approved = true;
                    //          } else {
                    //               this.disapproved = false;
                    //          }
                    //          this.isSaving = false;
                    //     }, () => {
                    //               this.disapproved = true;
                    //               this.isSaving = false;
                    //     })
               }
          });
    }
}


